









































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore";

@Component({
  name: "sort",
})
export default class sort extends Vue {
  private answer: Array<string> = [];
  private zItem!: any;
  @Prop({ type: String, default: "EDIT" }) viewMode!: string;

  @Prop({ type: Number, default: 0 }) zIndex!: number;
  @Prop({ type: Boolean, default: true }) showScore!: boolean;
  @Prop({ type: String, default: "" }) businessType!: string;
  @Prop({ type: Boolean, default: true }) Required!: boolean;
  @Watch("zIndex", { immediate: true })
  // eslint-disable-next-line
  watchIndex() {}
  @Prop({ type: Object, default: {} })
  item!: any;
  @Watch("item", { immediate: true, deep: true })
  dataChage(value: any) {
    this.zItem = value;
    if (this.viewMode == "ANSWERREVIEW") {
      if (value.answer) {
        this.answer = value.answer.map((as: any) => {
          return as.id;
        });
        let optionsList: any = [];
        value.answer.forEach((oas: any) => {
          let findop = this.item.optionsList.find((op: any) => {
            return oas.id == op.id;
          });
          if (findop) {
            findop.otherInputAnswer = oas.content;
            optionsList.push(findop);
          }
        });

        let otherOps = this.item.optionsList.filter((op: any) => {
          return !this.answer.includes(op.id);
        });

        optionsList.push(...otherOps);
        this.item.optionsList = optionsList;
      }
    }
  }

  get questionnaireType() {
    return this.businessType || QuestionnaireEditModule.questionnaireType;
  }

  get ruleDesc() {
    return "";
    /*  if (!this.data.jsonConfig) return "";
    const { selectRangeMin, selectRangeMax } = this.data.jsonConfig;
    const res: any = [];
    console.log("selectRangeMin, selectRangeMax", JSON.stringify(this.data.jsonConfig), selectRangeMin, selectRangeMax);
    // （最少选3项，最多选5项）
    if (selectRangeMin) {
      res.push(`最少选${selectRangeMin}项`);
    }
    if (selectRangeMax) {
      res.push(`最多选${selectRangeMax}项`);
    }
    if (res.length) {
      return `（${res.join("，")}）`;
    }*/
  }
}
